module.exports = __webpack_public_path__ + "img/31.24f267fc.png";